<div *ngIf="data" id="pipelineDrugContainer">
  <div class="heading">
    <span> Summary </span>
  </div>
  <div class="items-margin">
    <div id="pipeline">
      <div class="sub-heading">
        <span>Pipeline Stats</span>
      </div>
      <div class="items">
        <div class="letters">
          <span> Highest phase </span>
        </div>
        <div class="numbers">
          {{
            data.pipeline.highest_phase !== null &&
            data.pipeline.highest_phase !== undefined
              ? data.pipeline.highest_phase
              : "-"
          }}
        </div>
      </div>
      <div class="items">
        <div class="letters">
          <span> Current POS </span>
        </div>
        <div class="numbers">
          {{ data.pipeline.p_o_s_formatted }}
        </div>
      </div>
      <div class="items">
        <div class="letters">
          <span> Launch year </span>
        </div>
        <div class="numbers">
          {{
            data.pipeline.launch_year !== null &&
            data.pipeline.launch_year !== undefined
              ? data.pipeline.launch_year
              : "-"
          }}
        </div>
      </div>
      <div class="items">
        <div class="letters">
          <span>
            First 5 yrs of sale ({{ data.meta_data.currency
            }}{{ data.meta_data.magnitude }})
          </span>
        </div>
        <div class="numbers">
          {{ data.pipeline.five_year_aggregate_sum_formatted }}
        </div>
      </div>
    </div>
    <!-- <nz-divider class="divider"></nz-divider> -->
    <div id="peakStats">
      <div class="sub-heading">
        <span>Peak Sales</span>
      </div>
      <div class="items">
        <div class="letters">
          <span> Peak year </span>
        </div>
        <div class="numbers">
          {{
            data.pipeline.peak_year !== null &&
            data.pipeline.peak_year !== undefined
              ? data.pipeline.peak_year
              : "-"
          }}
        </div>
      </div>
      <div class="items">
        <div class="letters">
          <span>
            Peak sales (risk adjusted) ({{ data.meta_data.currency
            }}{{ data.meta_data.magnitude }})
          </span>

          <i
            nz-popover
            nzPopoverPlacement="right"
            nzPopoverContent="Peak revenue is calculated by taking the highest 
              value among our consensus data within our 
              forecast periods. If the first or the last 
              observable period is the peak, then we do not 
              list a peak value."
            nzPopoverTrigger="hover"
            class="info-icon-class"
            [nzPopoverOverlayStyle]="{ width: '261px' }"
          >
            <va-icon size="small" name="info-circle"></va-icon>
          </i>
        </div>
        <div class="numbers">
          {{ data.pipeline.peak_value_formatted }}
        </div>
      </div>
      <div class="items" hidden>
        <div class="letters">
          <span>
            Broker peaks (avg) ({{ data.meta_data.currency
            }}{{ data.meta_data.magnitude }})
          </span>
          <i
            nz-popover
            nzPopoverPlacement="right"
            nzPopoverContent="This is the calculated average of each broker's peak revenue estimate, 
              regardless of what year it falls in. This will provide a different peak 
              value when brokers disagree on the peak year."
            nzPopoverTrigger="hover"
            class="info-icon-class"
            [nzPopoverOverlayStyle]="{ width: '261px' }"
          >
            <va-icon size="small" name="info-circle"></va-icon>
          </i>
        </div>
        <div class="numbers">
          {{ data.pipeline.analyst_avg_value_formatted }}
        </div>
      </div>
    </div>
  </div>
</div>
